import { render } from "./SectionCaptacaoComercial.vue?vue&type=template&id=28078adf&scoped=true"
import script from "./SectionCaptacaoComercial.vue?vue&type=script&lang=js"
export * from "./SectionCaptacaoComercial.vue?vue&type=script&lang=js"

import "./SectionCaptacaoComercial.vue?vue&type=style&index=0&id=28078adf&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28078adf"]])

export default __exports__